import React from "react";
//#region types
import { FormFieldContainerProps } from "models/propTypes/genericFormProps";
import { FieldConstants } from "utils/constants";
//#endregion
//#region components
import FormField from "../forms/formField";
//#endregion
import { UtilsHelper } from "utils/helpers";

function FormFieldContainer<T extends Record<string, any>>(props: FormFieldContainerProps<T>) {
  const {
    value,
    errors,
    touched,
    setFieldTouched,
    setFieldValue,
    disabled,
    optional,
    onChangeFromUIHandler,
    readonly,
    loading,
  } = props;

  const handleOnChange = React.useCallback(async (name: string, e: React.ChangeEvent<any>) => {
    e.persist();
    const target = e.target;
    const updatedValue = target.type === "checkbox" ? target.checked : target.value;

    setFieldTouched(name, false, false);
    onChangeFromUIHandler(updatedValue);
    setFieldValue(name, updatedValue, true);
  }, []);

  const handleOnChangeCustom = React.useCallback(
    (name: string, data: any, setTouched?: boolean, referenceFieldName?: string, referenceData?: any) => {
      setFieldTouched(name, setTouched ?? false, false);
      onChangeFromUIHandler(data);
      if (referenceFieldName) {
        setFieldValue(referenceFieldName, referenceData, false);
        setTimeout(() => {
          setFieldValue(name, data, true);
        });
      } else {
        setFieldValue(name, data, true);
      }
    },
    []
  );

  const handleOnBlurCustom = React.useCallback((name: string) => {
    setTimeout(() => {
      setFieldTouched(name, true, !touched && UtilsHelper.isEmpty(value));
    }, FieldConstants.DebounceTime);
  }, []);

  const component = React.useMemo(
    () => (
      <FormField
        fieldRef={props.fieldRef}
        name={props.name}
        field={props.field}
        hideErrorBubble={props.hideErrorBubble}
        hideSuccess={props.hideSuccess}
        messagePlacement={props.messagePlacement}
        invertedDisplayType={props.invertedDisplayType}
        inline={props.inline}
        enableControlLables={props.enableControlLables}
        contentWidth={props.contentWidth}
        formGridLayout={props.formGridLayout}
        layout={props.layout}
        validationSchema={props.validationSchema}
        overrideOptional={props.overrideOptional}
        hideOptionalIndicator={props.hideOptionalIndicator}
        focusField={props.focusField}
        value={props.value}
        touched={touched}
        errors={touched && errors}
        success={false}
        optional={optional}
        disabled={disabled}
        readonly={readonly}
        loading={loading}
        handleOnChange={handleOnChange}
        handleOnChangeCustom={handleOnChangeCustom}
        handleOnBlurCustom={handleOnBlurCustom}
      />
    ),
    [props, handleOnChange, handleOnChangeCustom, handleOnBlurCustom]
  );

  return component;
}

export default FormFieldContainer;
